/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyCheck',
  standalone: true
})
export class EmptyCheckPipe implements PipeTransform {

  transform(value: string): boolean {
    return value?.trim()?.length == 0;
  }

}
